import i18n from 'i18next'
import { ROLES } from 'modules/core/constants'
import { getOperationsByKeys, getPeriodOperationsKeys, isUserAllowed } from 'modules/core/utils'
import {
  RightOutlined,
  NodeIndexOutlined,
  FileTextOutlined,
  BarsOutlined,
  BarChartOutlined,
  CalendarOutlined,
  ToolOutlined,
  SafetyOutlined,
} from '@ant-design/icons'
import { Tooltip } from 'antd'

const {
  SETTINGS__BUDGET_TYPE,
  SETTINGS__DIMENSIONS,
  SETTINGS__REPORTS,
  SETTINGS__SECURITY,
  SETTINGS__SECURITY__USERS,
  SETTINGS__SECURITY__ROLES,
  SETTINGS__PROJECTION_ELEMENTS,
  SETTINGS__PROJECTION_ELEMENTS__BUSINESS_RULES,
  SETTINGS__PROJECTION_ELEMENTS__CURRENCY,
} = ROLES

const PROJECTION_ELEMENTS_TYPE = {
  rules: {
    role: [SETTINGS__PROJECTION_ELEMENTS__BUSINESS_RULES],
  },
  currency: {
    role: [SETTINGS__PROJECTION_ELEMENTS__CURRENCY],
  },
}

const generateOptions = (enabledWorkflow) => {
  return [
    ...(enabledWorkflow
      ? [
          {
            id: 'workflows',
            name: 'Workflows',
          },
        ]
      : [
          {
            id: 'credentials',
            name: 'INTEGRATIONS_CREDENTIALS_TAB_TITLE',
          },
        ]),
  ]
}

const renderTooltipTools = (key) => {
  if (key === 'rules') return i18n.t('CONFIG_RULES_INFORMATIVE_TOOLTIP_TITLE')
  if (key === 'currency') return i18n.t('CONFIG_CURRENCY_INFORMATIVE_TOOLTIP_TITLE')
  return ''
}

export const listDataConfigModules = ({
  dimensionsList,
  budgetTypeList,
  reportList,
  modifiersList,
  history,
  enabledWorkflow,
  periodList,
}) => [
  {
    title: i18n.t('LABEL_INTEGRATION'),
    url: '/configuracion/integraciones/credentials',
    key: 'reports',
    allowedFor: [SETTINGS__REPORTS],
    icon: <NodeIndexOutlined style={{ fontSize: 36 }} />,
    count: generateOptions(enabledWorkflow).length,
    disabled: false,
    renderListItem: generateOptions(enabledWorkflow).map((integation) => (
      <li
        key={integation.id}
        onClick={() => history.push(`/configuracion/integraciones/${integation.id}`)}
      >
        {i18n.t(integation.name)}
        <RightOutlined className="enter-icon" />
      </li>
    )),
  },
  {
    title: i18n.t('LABEL_PERIODS'),
    url: '/configuracion/periodos/',
    key: 'periods',
    allowedFor: getPeriodOperationsKeys(),
    icon: <CalendarOutlined style={{ fontSize: 36 }} />,
    count: periodList.length,
    disabled: false,
  },
  {
    title: i18n.t('LABEL_DIMENSIONS'),
    url: '/configuracion/dimensiones/',
    key: 'dimensions',
    allowedFor: [SETTINGS__DIMENSIONS],
    icon: <FileTextOutlined style={{ fontSize: 36 }} />,
    disabled: dimensionsList.count === 0,
    count: dimensionsList.count,
    renderListItem:
      dimensionsList.count !== 0 &&
      dimensionsList.values.map((dimension) => (
        <li
          key={dimension.id}
          onClick={() => history.push(`/configuracion/dimensiones/${dimension.id}`)}
        >
          {dimension.name_destination}
          <RightOutlined className="enter-icon" />
        </li>
      )),
    tooltipText: i18n.t('CONFIG_DIMENSIONS_INFORMATIVE_TOOLTIP_TITLE'),
  },
  {
    title: i18n.t('LABEL_BUDGET_TYPE'),
    url: '/configuracion/tipodepresupuesto/',
    key: 'concepts',
    allowedFor: [SETTINGS__BUDGET_TYPE],
    icon: <BarsOutlined style={{ fontSize: 36 }} />,
    count: budgetTypeList?.count,
    renderListItem:
      budgetTypeList?.count !== 0 &&
      budgetTypeList?.values.map((type) => <li key={type.id}>{i18n.t(type.name)}</li>),
    tooltipText: i18n.t('CONFIG_BUDGET_TYPE_INFORMATIVE_TOOLTIP_TITLE'),
  },
  {
    title: i18n.t('LABEL_REPORTS'),
    url: '/configuracion/reportes/',
    key: 'reports',
    allowedFor: [SETTINGS__REPORTS],
    icon: <BarChartOutlined style={{ fontSize: 36 }} />,
    count: reportList.count,
    disabled: dimensionsList.count === 0,
    renderListItem: reportList.values.map((report) => (
      <li
        key={report.id}
        className={dimensionsList.count === 0 ? 'li-report' : ''}
        onClick={() =>
          dimensionsList.count !== 0 && history.push(`/configuracion/reportes/${report.id}`)
        }
      >
        {i18n.t(report.name)}
        <RightOutlined className="enter-icon" />
      </li>
    )),
    tooltipText: i18n.t('CONFIG_REPORTS_INFORMATIVE_TOOLTIP_TITLE'),
  },
  {
    title: i18n.t('LABEL_TOOLS'),
    url: '/configuracion/herramientas/rules',
    key: 'projectionElements',
    allowedFor: [SETTINGS__PROJECTION_ELEMENTS],
    icon: <ToolOutlined style={{ fontSize: 36 }} />,
    count: modifiersList.values.length,
    disabled: dimensionsList.count === 0,
    renderListItem: modifiersList.values.map(
      (modifier) =>
        isUserAllowed(getOperationsByKeys(PROJECTION_ELEMENTS_TYPE[modifier.key].role)) && (
          <Tooltip key={modifier.key} title={renderTooltipTools(modifier.key)}>
            <li
              key={modifier.key}
              onClick={() => history.push(`/configuracion/herramientas/${modifier.key}`)}
            >
              {i18n.t(modifier.name)}
              <RightOutlined className="enter-icon" />
            </li>
          </Tooltip>
        ),
    ),
  },
  {
    title: i18n.t('LABEL_SECURITY'),
    url: '/configuracion/seguridad/users',
    key: 'security',
    allowedFor: [SETTINGS__SECURITY],
    icon: <SafetyOutlined style={{ fontSize: 36 }} />,
    count: 3,
    renderListItem: (
      <>
        {isUserAllowed(getOperationsByKeys([SETTINGS__SECURITY__USERS])) && (
          <li
            onClick={() => history.push(`/configuracion/seguridad/users`)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                history.push(`/configuracion/seguridad/users`)
              }
            }}
          >
            {i18n.t('LABEL_USERS')}
            <RightOutlined className="enter-icon" />
          </li>
        )}
        {isUserAllowed(getOperationsByKeys([SETTINGS__SECURITY__ROLES])) && (
          <Tooltip title={i18n.t('CONFIG_ROLE_INFORMATIVE_TOOLTIP_TITLE')}>
            <li
              onClick={() => history.push(`/configuracion/seguridad/roles`)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  history.push(`/configuracion/seguridad/roles`)
                }
              }}
            >
              {i18n.t('LABEL_ROLES')}
              <RightOutlined className="enter-icon" />
            </li>
          </Tooltip>
        )}
        <li
          onClick={() => history.push(`/configuracion/seguridad/areas`)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              history.push(`/configuracion/seguridad/areas`)
            }
          }}
        >
          {i18n.t('LABEL_AREAS')}
          <RightOutlined className="enter-icon" />
        </li>
      </>
    ),
    tooltipText: i18n.t('CONFIG_SECURITY_INFORMATIVE_TOOLTIP_TITLE'),
  },
]
